/**
 * Short, consistent wording for a set of proposal structures — used by the
 * structure dropdown trigger, track chips, approval-trail lanes and supplier
 * portal section headers so every surface says the same thing.
 */

export const WHOLE_PROJECT_SELECTION_LABEL = 'Whole project';

/** "Whole project" / "Barn" / "Barn + Pavilion" / "Barn + Pavilion +2". */
export function structureSelectionLabel(names: ReadonlyArray<string>, opts?: { empty?: string; maxNamed?: number }): string {
  const clean = names.map(n => (n || '').trim()).filter(Boolean);
  if (clean.length === 0) return opts?.empty ?? WHOLE_PROJECT_SELECTION_LABEL;
  const maxNamed = Math.max(1, opts?.maxNamed ?? 2);
  if (clean.length <= maxNamed) return clean.join(' + ');
  const shown = clean.slice(0, maxNamed).join(' + ');
  return `${shown} +${clean.length - maxNamed}`;
}

/** Full comma list for tooltips; empty for whole project. */
export function structureSelectionTitle(names: ReadonlyArray<string>): string | undefined {
  const clean = names.map(n => (n || '').trim()).filter(Boolean);
  return clean.length > 1 ? clean.join(', ') : undefined;
}

/** Stable key for a structure *set* (order-independent) — groups tracks / releases that cover the same scope. */
export function structureSetKey(ids: ReadonlyArray<string>): string {
  const clean = Array.from(new Set(ids.map(id => (id || '').trim()).filter(Boolean))).sort();
  return clean.length === 0 ? '__whole_project__' : clean.join('|');
}
